/**
    companyName: '',
    siteName: '',
    ledgerName: '',
    operationType: '',
    accidentNo: '',
    feeSupplierName: '',
    profitTypeName: '',
    initialTotalAmt: '',
    chargeoffTime: '',
    currencyCode: '',
    isReplaceSettlement: '',
    remark: '',
    isAccident: '',
    totalAmt: ''
 *
 */
export default class LoadAndUnloadClass {
    constructor({ companyName, siteName, ledgerName, operationType, accidentNo, feeSupplierName, profitTypeName,
        initialTotalAmt, chargeoffTime, currencyCode, isReplaceSettlement, remark, isAccident, totalAmt }) {
        this.companyName = companyName || '';
        this.siteName = siteName || '';
        this.ledgerName = ledgerName || '';
        this.operationType = operationType || '';
        this.accidentNo = accidentNo || '';
        this.feeSupplierName = feeSupplierName || '';
        this.profitTypeName = profitTypeName || '';
        this.initialTotalAmt = initialTotalAmt || '';
        this.chargeoffTime = chargeoffTime || '';
        this.currencyCode = currencyCode || '';
        this.isReplaceSettlement = isReplaceSettlement || '';
        this.remark = remark || '';
        this.isAccident = isAccident || '';
        this.totalAmt = totalAmt || '';
    }
}

export function initOrgonaztion(data) {
    return new LoadAndUnloadClass(data);
}